import { paths } from '@AppRoutes/constants.js';

export default {
  quickSearch: {
    id: 'general-menu-quick-search',
    label: 'Quick search',
    path: paths.SEARCH,
  },
  queryBuilder: {
    id: 'general-menu-query-builder',
    label: 'Query builder',
    path: paths.ADVANCED,
  },
  results: {
    id: 'general-menu-results',
    label: 'Results',
    path: '#',
  },
  alerts: {
    id: 'general-menu-alerts',
    label: 'Alerts',
    path: paths.ALERTS,
  },
  retrosynthesis: {
    id: 'general-menu-retrosynthesis',
    label: 'Retrosynthesis',
    path: paths.RS,
  },
  history: {
    id: 'general-menu-historyNav',
    label: 'History',
    path: paths.HISTORY_RECENT,
  },
  historySaved: {
    id: 'general-menu-historyNav',
    label: 'History',
    path: paths.HISTORY_SAVED,
  },
  texel: {
    id: 'general-menu-texel',
    label: 'Semantic Search',
  },
};
